module.exports = __webpack_public_path__ + "static/img/img-Tbi.07668e5d.png";